import React from 'react';
import Layout from '../../../layout';
import Download from './download';


export default function Index() {

    return (
        <Layout>
            <Download />
            <br />
            <br />
            <br />
            <br />
            <br />
        </Layout>
    )
}
